var printDoc = (function(){

    function groupHeadingsWithNext(){
 
       var paras = document.querySelectorAll('h1 + *, h2 + *, h3 + *, h4 + *');

        paras.forEach(p => {

            var prevEl = p.previousElementSibling;

            // cancel, if previous element is not a heading
            if(
                !prevEl.tagName == 'H2' ||
                !prevEl.tagName == 'H3' ||
                !prevEl.tagName == 'H4' ||
                !prevEl.tagName == 'H5' 

            ) return

            // get heading

            var heading = p.previousElementSibling;

            // make wraper

            var wraper = document.createElement('div')

            wraper.classList.add('print-keep')

            // inject wraper before heading

            heading.parentElement.insertBefore(wraper,heading)

            // move both heading and paragraph inside wrapper

            wraper.appendChild(heading) 

            wraper.appendChild(p)

        })

        
    }

    return {

           groupHeadingsWithNext: groupHeadingsWithNext
    
    }
   

})();

document.addEventListener('click', function(e){

    if(!e.target.closest('#print-document')) return;

    printDoc.groupHeadingsWithNext()
    
    window.print();
    
})